
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const CaretBackwardIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M26.803 53.6051C23.0657 50.8005 23.0657 45.1994 26.803 42.3948L54.7634 21.4123C59.3771 17.95 66 21.2206 66 27.0174V68.9825C66 74.7794 59.377 78.0499 54.7634 74.5877L26.803 53.6051ZM31 47.9999L59 68.9999V26.9999L31 47.9999Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28.9038 50.8057C27.0321 49.4012 27.0321 46.5989 28.9038 45.1943L56.8642 24.2117C59.1839 22.4709 62.5 24.1218 62.5 27.0175V68.9826C62.5 71.8782 59.1839 73.5291 56.8642 71.7883L28.9038 50.8057Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M69.197 53.6051C72.9343 50.8005 72.9343 45.1994 69.197 42.3948L41.2366 21.4123C36.623 17.95 30 21.2206 30 27.0174L30 68.9825C30 74.7794 36.623 78.0499 41.2366 74.5877L69.197 53.6051ZM65 47.9999L37 68.9999L37 26.9999L65 47.9999Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M67.0962 50.8057C68.9679 49.4012 68.9679 46.5989 67.0962 45.1943L39.1358 24.2117C36.8161 22.4709 33.5 24.1218 33.5 27.0175L33.5 68.9826C33.5 71.8782 36.8161 73.5291 39.1358 71.7883L67.0962 50.8057Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
